import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetAllAnalysisLibrary } from "services/analysisLibrary";
import {
	adminGetAllAnalysesPack,
	adminGetAnalysesPack,
	adminPatchAnalysesPack,
	adminPostAnalysesPack,
	adminDeleteAnalysesPack,
	resetFocusAnalysesPack,
	initNewAnalysesPack,
} from "services/analysesPack";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/AnalysesPacks/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import AnalysesForm from "features/Admin/AnalysesPacks/Forms/AnalysesForm";
import * as Yup from "yup";
import { isJson } from "utils/json";

const schemaValidation = Yup.object().shape({
	label: Yup.string().required("Champ requis"),
	color: Yup.string().required("Champ requis"),
});

class AnalysesPackAdmin extends Component {
	constructor(props) {
		super(props);

		this.state = {
			analysesFactory: {
				list: this.props.analyses.list.data,
				listLabel: "Liste des analyses",
				selectedLabel: "Analyses sélectionnées",
				value: null,
			},
			colorPicker: false,
		};
	}

	componentDidMount() {
		this.getAllElements();

		if (this.props.analysesPacks.focus.data !== null) {
			this.setupFactories(this.props.analysesPacks.focus.data);
		}
	}

	setupFactories = (elt) => {
		this.setState({
			analysesFactory: {
				list: this.props.analyses.list.data
					.filter((a) => a.status !== "UNACTIVE")
					.map((i) => {
						return {
							id: i.id,
							name: `${i.code} (${i.label})`,
						};
					}),
				listLabel: this.state.analysesFactory.listLabel,
				selectedLabel: this.state.analysesFactory.selectedLabel,
				value:
					elt && elt.analysesPackages && elt.analysesPackages.length > 0
						? elt.analysesPackages
								.slice()
								.sort((a, b) => a.position - b.position)
								.map((i) => {
									return JSON.stringify({
										id: i.analysis.id,
										name: `${i.analysis.code} (${i.analysis.label})`,
									});
								})
						: [],
			},
		});
	};

	resetFactories = () => {
		this.setState({
			analysesFactory: {
				list: this.state.analysesFactory.list,
				listLabel: this.state.analysesFactory.listLabel,
				selectedLabel: this.state.analysesFactory.selectedLabel,
				value: this.state.analysesFactory.value,
			},
		});
	};

	componentWillUnmount() {
		this.props.resetFocusAnalysesPack();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.analysesPacks.focus.data !== prevProps.analysesPacks.focus.data) {
			this.setupFactories(this.props.analysesPacks.focus.data);
		}
	}

	getAllElements = () => {
		this.props.adminGetAllAnalysisLibrary();
		this.props.adminGetAllAnalysesPack();
	};

	focusOnElement = (elt) => {
		this.props.adminGetAnalysesPack(elt);
	};

	onAddClick = () => {
		this.props.initNewAnalysesPack();
	};

	saveFocus = (values, setSubmitting) => {
		// Handle analyses
		values.analysesTmp = {
			value: this.state.analysesFactory.value
				.filter((s) => isJson(s))
				.map((selected) => {
					const selectedParsed = JSON.parse(selected);
					return selectedParsed.id;
				}),
		};

		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostAnalysesPack(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchAnalysesPack(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteAnalysesPack(this.props.analysesPacks.focus.data);
	};

	openColorPicker = () => {
		this.setState({ colorPicker: true });
	};

	closeColorPicker = () => {
		this.setState({ colorPicker: false });
	};

	updateFactoryValue = (newSelected) => {
		this.setState((prevState) => ({
			...prevState,
			analysesFactory: {
				...prevState.analysesFactory,
				value: newSelected,
			},
		}));
	};

	render() {
		let analysesPack = this.props.analysesPacks.focus.data;
		let { focus, list } = this.props.analysesPacks;
		let newAnalysesPack = analysesPack !== null && analysesPack.id === undefined;
		let { analysesFactory } = this.state;
		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={this.props.analysesPacks.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="PACKS D'ANALYSES"
					addButtonText="Nouveau pack"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					focusedEltId={analysesPack}
				/>
				<ElementFocus element={focus} list={list} entity="Packs d'analyses" icon="lab">
					{analysesPack !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: analysesPack.id,
								label: analysesPack.label || "",
								name: analysesPack.name || "",
								color: analysesPack.color || "#fff",
								group: analysesPack.group || "",
								doctor: analysesPack.doctor || "",
								doctor_source: analysesPack.doctor_source || null,
								only_for_campaign: analysesPack.only_for_campaign || false,
								only_for_deposit: analysesPack.only_for_deposit || false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, setFieldValue, values, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusAnalysesPack}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newAnalysesPack ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newAnalysesPack && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={2}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm
														openColorPicker={this.openColorPicker}
														closeColorPicker={this.closeColorPicker}
														colorPicker={this.state.colorPicker}
														values={values}
														setFieldValue={setFieldValue}
													/>
												</AdminDataContainer>
											</Grid.Column>
											<Grid.Column>
												<AdminDataContainer ribbonColor="purple" ribbonLabel="Analyses">
													{this.state.analysesFactory.value ? (
														<AnalysesForm updateAnalyses={this.updateFactoryValue} analysesFactory={analysesFactory} />
													) : null}
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteAnalysesPackAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		analyses: state.admin.analyses,
		analysesPacks: state.admin.analysesPacks,
	};
};

const mapDispatchToProps = {
	adminGetAllAnalysisLibrary,
	adminGetAllAnalysesPack,
	adminGetAnalysesPack,
	adminPatchAnalysesPack,
	adminDeleteAnalysesPack,
	resetFocusAnalysesPack,
	adminPostAnalysesPack,
	initNewAnalysesPack,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalysesPackAdmin);
